import React, { useContext } from "react";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";
import EmailLoggerRow from "./EmailLoggerRow";
import * as FaIcons from "react-icons/fa";

const headers = [
  { name: "createdAt", display: "Submit Date" },
  { name: "learningCenterName", display: "Learning Center" },
  { name: "fromEmail", display: "From Email" },
  { name: "recipientEmail", display: "To Email" },
  { name: "emailType", display: "Email Type" },
  { name: "relatedRecordId", display: "Related Record Id" },
  { name: "errorMessage", display: "Error Message" },
  { name: "status", display: "Status"},
  { name: "actions", display: "Actions" }
];

const TableHeaderItem = ({ name, display }) => {
  const adminemailLogsContext = useContext(AdminemailLogsContext);
  const { sortOptions, onTableFilter } = adminemailLogsContext;

  // Safety check to ensure sortOptions[name] exists
  const sortOption = sortOptions[name] || { asc: false, desc: false };
  
  return (
    <th onClick={() => onTableFilter(name)} style={{ whiteSpace: 'nowrap' }}>
      <div className="wrap" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <span style={{ whiteSpace: 'nowrap' }}>{display}</span>
        <div className="filter" style={{ display: 'flex', flexDirection: 'column' }}>
          <FaIcons.FaSortUp
            style={{
              color: sortOption.asc ? "#343434" : "white",
            }}
          />
          <FaIcons.FaSortDown
            style={{
              color: sortOption.desc ? "#343434" : "white",
              marginTop: '-6px'
            }}
          />
        </div>
      </div>
    </th>
  );
};

const EmailLoggerTable = ({ items, history }) => {
  const adminemailLogsContext = useContext(AdminemailLogsContext);
  const { ageOver, visibleColumns } = adminemailLogsContext;

  // Filter headers based on visibility
  const visibleHeaders = headers.filter(header => {
    // Check if column is visible in context
    if (visibleColumns && visibleColumns[header.name] === false) {
      return false;
    }
    return true;
  });

  return (
    <div className="interest-form-table">
      <div className="table-responsive">
        <table className="responsive-table" id="interest-table">
          <thead>
            <tr>
              {visibleHeaders.map((header) => (
                <TableHeaderItem key={header.name} name={header.name} display={header.display} />
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              return <EmailLoggerRow key={item._id} info={item} history={history} visibleColumns={visibleColumns} />;
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmailLoggerTable;